/**
 * Bancada da abertura animada: repete o splash por cima desta tela, em câmera
 * lenta se quiser, com o app "demorando" para ver o loop ocioso. Só em dev.
 */
import { AnimatedSplash } from '@/components/animated-splash';
import { ThemedText } from '@/components/themed-text';
import { Button } from '@/components/ui/button';
import { Redirect } from 'expo-router';
import React, { useEffect, useState } from 'react';
import { ScrollView, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const SPEEDS = [1, 0.5, 0.25];
const READY_DELAYS = [0, 3000];

export default function SplashBench() {
  if (!__DEV__) {
    return <Redirect href="/" />;
  }
  return <SplashBenchDev />;
}

function SplashBenchDev() {
  const insets = useSafeAreaInsets();
  const [run, setRun] = useState(1);
  const [playing, setPlaying] = useState(true);
  const [ready, setReady] = useState(false);
  const [speed, setSpeed] = useState(1);
  const [readyDelay, setReadyDelay] = useState(0);
  const [reduced, setReduced] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (!playing) return;
    setReady(false);
    const id = setTimeout(() => setReady(true), readyDelay / speed);
    return () => clearTimeout(id);
  }, [run, playing, readyDelay, speed]);

  const replay = () => {
    setRun((n) => n + 1);
    setPlaying(true);
  };

  return (
    <View className="flex-1 bg-background">
      <ScrollView
        keyboardShouldPersistTaps="handled"
        contentContainerStyle={{ paddingTop: insets.top + 16, padding: 16, gap: 12 }}
      >
        <View className="h-40 justify-end rounded-2xl bg-primary p-4">
          <ThemedText className="font-bold text-xl text-white">Bom dia, Ana</ThemedText>
          <ThemedText className="text-sm text-white/80">3 aulas hoje · R$ 480 a receber</ThemedText>
        </View>
        {[0, 1, 2].map((i) => (
          <View key={i} className="h-16 rounded-2xl border border-neutral-900/5 bg-card" />
        ))}

        <Button title="Repetir" onPress={replay} />
        <Button
          title={`Velocidade: ${speed}x`}
          variant="outline"
          onPress={() => setSpeed(SPEEDS[(SPEEDS.indexOf(speed) + 1) % SPEEDS.length])}
        />
        <Button
          title={
            readyDelay
              ? `App pronto após ${readyDelay / 1000}s (loop ocioso)`
              : 'App pronto na hora'
          }
          variant="outline"
          onPress={() =>
            setReadyDelay(
              READY_DELAYS[(READY_DELAYS.indexOf(readyDelay) + 1) % READY_DELAYS.length],
            )
          }
        />
        <Button
          title={`Movimento reduzido: ${reduced === undefined ? 'sistema' : reduced ? 'sim' : 'não'}`}
          variant="outline"
          onPress={() => setReduced((r) => (r === undefined ? true : r ? false : undefined))}
        />
      </ScrollView>

      {playing ? (
        <AnimatedSplash
          key={run}
          ready={ready}
          speed={speed}
          reduceMotion={reduced}
          hideNativeSplash={false}
          onFinish={() => setPlaying(false)}
        />
      ) : null}
    </View>
  );
}
